/* unplugin-vue-components disabled */import script from "./ApplicationClassification.vue?vue&type=script&setup=true&name=ApplicationClassification&lang=js"
export * from "./ApplicationClassification.vue?vue&type=script&setup=true&name=ApplicationClassification&lang=js"

import "./ApplicationClassification.vue?vue&type=style&index=0&id=34729630&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34729630"]])

export default __exports__